export class CommessaSearchModel {
  client_name?: string = "";
  number?: string = "";
  createdAt?: Date = undefined;
}
